import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { isPresent } from 'utils/helperMethods';
import { useTranslation } from 'react-i18next';

import Avatar from 'sharedComponents/Avatar';
import Icon from 'sharedComponents/Icon';
import LoanOfficerPresenter from 'presenters/realEstateAgent/LoanOfficerPresenter';

import { Typography, IconButton } from '@material-ui/core';

import useStyles from './useStyles';

const LoanOfficerCard = props => {
  const { loanOfficer, isDeleting, onDelete } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const [deleting, setDeleting] = useState(false);
  const shouldShowDeleteIcon = !deleting;
  const isCompanyLogotypePresent = isPresent(LoanOfficerPresenter.companyLogoUrl(loanOfficer));

  const handleRemove = () => {
    onDelete(LoanOfficerPresenter.loanOfficerId(loanOfficer));
    setDeleting(true);
  };

  return (
    <div className={clsx(classes.container, { [classes.disabled]: deleting })}>
      <div className={classes.topBar}>
        <Avatar size="m" imageUrl={LoanOfficerPresenter.profileImageUrl(loanOfficer)} />
        <div className={classes.loanOfficerBadge}>
          <Typography noWrap variant="subtitle1" color="secondary">
            {t('models.App.userTypes.loanOfficer')}
          </Typography>
          <Typography noWrap variant="h3" className={classes.name}>
            {LoanOfficerPresenter.loanOfficerName(loanOfficer)}
          </Typography>
        </div>
        {isCompanyLogotypePresent && (
          <img
            alt="company logo"
            src={LoanOfficerPresenter.companyLogoUrl(loanOfficer)}
            className={classes.companyLogo}
          />
        )}
      </div>
      <div className={classes.bottomBar}>
        <div className={classes.infoBox}>
          <Typography variant="subtitle1" color="secondary">
            {t('components.RealEstateAgentLoanOfficers.FavoriteLoanOfficersList.LoanOfficerCard.nmls')}
          </Typography>
          <Typography noWrap variant="h3" color="inherit" className={classes.label}>
            {LoanOfficerPresenter.nmls(loanOfficer)}
          </Typography>
        </div>
        <div className={classes.locationBadge}>
          <Typography variant="subtitle1" color="secondary">
            {t('components.RealEstateAgentLoanOfficers.FavoriteLoanOfficersList.LoanOfficerCard.branchLocation')}
          </Typography>
          <Typography noWrap variant="h3" color="inherit" className={classes.label}>
            {LoanOfficerPresenter.branchLocation(loanOfficer)}
          </Typography>
        </div>
      </div>
      {shouldShowDeleteIcon && (
        <IconButton className={classes.removeButton} onClick={handleRemove} disabled={isDeleting}>
          <Icon name="close" />
        </IconButton>
      )}
    </div>
  );
};

LoanOfficerCard.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape().isRequired,
  isDeleting: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default LoanOfficerCard;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/FavoriteLoanOfficersList/components/LoanOfficerCard/LoanOfficerCard.js